import axios from 'axios';

const InvoiceService = {
  async getInvoice(id) {
    const response = await axios.get(`/invoice/${id}`);

    return response.data;
  },

  async createInvoice({ loanId, formValues }) {
    const response = await axios.post(`/invoice`, {
      loan_id: loanId,
      ...formValues,
    });

    return response.data;
  },

  async updateInvoice({ invoiceId, data }) {
    const response = await axios.put(`/invoice/${invoiceId}`, data);

    return response.data;
  },

  async deleteInvoice(id) {
    const response = await axios.delete(`/invoice/${id}`);

    return response.data;
  },

  async refundInvoice(id) {
    const response = await axios.post(`/invoice/${id}/refund`);

    return response.data;
  },
};

export default InvoiceService;
